import React from 'react';
import './BlockComponent.css';

export default function ImageBlock(props) {
  const { src, displayHeight, linkDestination } = props.data;
  return (
    <div className="youtube-video-wrapper">
      <iframe
        width="560"
        height="315"
        src={src}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
